<template>
  <div id="Default">
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex'

export default {
}
</script>

<style lang="scss">

</style>